<template>
  <vx-card ref="Whole_Page" id="moduleInfoCard" v-show="isCardActiveLocal" :title="moduleCardTitle">
    <div class="vx-row pb-3">
      <div class="vx-col w-full mb-2">
        <label>Name</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" class="w-full" v-validate="'required'" name="Title" v-model="moduleData.name" />
        <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
      </div>
    </div>
    <div class="vx-row pb-3">
      <div class="vx-col w-full mb-2">
        <label>Description</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" class="w-full" v-validate="'required'" name="Description" v-model="moduleData.description" />
        <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
      </div>
    </div>
    <div class="vx-row" v-if="$siteTypeId() != 1">
      <div class="vx-col xs:w-full sm:w-full ml:w-full lg:w-1/3 xl:1/3 mb-2">
        <label>SAQA Id</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" class="w-full"  name="SaqaId" v-model="moduleData.saqaId" />
      </div>
      <div class="vx-col xs:w-full sm:w-full ml:w-full lg:w-1/3 xl:1/3 mb-2">
        <label>NQF level</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" class="w-full"  name="NqfLevel" v-model="moduleData.nqfLevel" />
      </div>
      <div class="vx-col xs:w-full sm:w-full ml:w-full lg:w-1/3 xl:1/3 mb-2">
        <label>Credits</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" v-validate="'numeric'" class="w-full" name="Credits" v-model="moduleData.credits" />
        <span class="text-danger text-sm" v-show="errors.has('Credits')">{{ errors.first('Credits') }}</span>
      </div>
    </div>
    <div v-if="$siteTypeId() == 1 && !isCourseReadOnly" class="vx-row pb-3">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label>{{ $siteTypeId() == 1 ? 'Module' : 'Category' }}</label>
        <v-select ref="categoryDropdown" class="w-full style-chooser" :placeholder="$siteTypeId() == 1 ? 'Search / Select Module' : 'Search / Select Category'" :options="categories" v-model="categoryDropdown"></v-select>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label>{{ $siteTypeId() == 1 ? 'Term' : 'Group' }}</label>
        <v-select ref="groupDropdown" class="w-full style-chooser" :placeholder="$siteTypeId() == 1 ? 'Search / Select Term' : 'Search / Select Group'" :options="groups" v-model="groupDropdown"></v-select>
      </div>
    </div>
    <div v-if="$siteTypeId() == 1 && isCourseReadOnly" class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label>Category</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" class="w-full" v-model="moduleData.moduleCategoryName" />
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label>Group</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" class="w-full" v-model="moduleData.moduleGroupName" />
      </div>
    </div>
    <div class="vx-row pb-2">
      <div class="vx-col sm:w-1/4 w-full mb-2 mt-1" v-if="$siteTypeId() != 1">
        <p> Learning Style </p>
          <div class="centex mt-1">
            <vs-switch v-model="moduleData.learningStyleB" :disabled="isCourseReadOnly || !moduleData.id == 0" id="vsswitch">
              <span slot="off">Story Based</span>
              <span slot="on">Module Based</span>
            </vs-switch>
          </div>
      </div>
    </div>
    <div class="vx-row pb-1" v-if="$siteTypeId() == 1">
      <div class="vx-col sm:w-1/4 w-full mt-1">
        <p>Curriculum Configuration</p>
        <div class="centex mb-3 mt-1">
          <vs-switch v-model="moduleData.forTrimmedDownCurriculum" :disabled="isCourseReadOnly" id="vsswitch">
            <span slot="off">Normal</span>
            <span slot="on">Stripped-Down</span>
          </vs-switch>
        </div>
      </div>
    </div>
    <div v-if="!moduleData.learningStyleB && $siteTypeId() != 1" class="vx-row pb-3">
      <div class="vx-col sm:w-1/4 w-full info-next-to-checkcss">
        <vs-checkbox v-model="moduleData.backActive" :disabled="isCourseReadOnly" >Enable Back</vs-checkbox>
        <vx-tooltip 
          text='This enables students to go back to previous tasks.' 
          position="bottom"
          class="info-icon-on-module" 
          delay=".3s">
            <feather-icon
              svgClasses="h-6 w-6"
              class="p-2 cursor-pointer"
              icon="InfoIcon"
            ></feather-icon>
        </vx-tooltip>
      </div>
      <!-- <div class=" vx-col sm:w-1/4 w-full"></div>
      <div class=" vx-col sm:w-1/4 w-full">
          <label>Total Coins</label>
          <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" class="w-full" v-validate="'numeric'" name="Total Coins" v-model="moduleData.coinCount" />
          <span class="text-danger text-sm" v-show="errors.has('Total Coins')">{{ errors.first('Total Coins') }}</span>
      </div> -->
    </div>
    <div class="vx-row pb-3">
      <div class="vx-col sm:w-1/4 w-full">
        <label>Start Task</label>
        <vs-select placeholder="Select Start Task" :disabled="isCourseReadOnly" class="w-full vs-con-loading__container" vs-multiple autocomplete v-model="moduleData.startTaskId">
          <vs-select-item :key="index" :value="task.value" :text="task.text" v-for="(task,index) in moduleTasks" />
        </vs-select>
      </div>
      <div class=" vx-col sm:w-1/4 w-full"></div>
      <div class="vx-col sm:w-1/4 w-full mt-2">
        <label>End Task</label>
        <vs-select placeholder="Select End Task" :disabled="isCourseReadOnly" class="w-full vs-con-loading__container" vs-multiple autocomplete v-model="moduleData.endTaskId">
          <vs-select-item :key="index" :value="task.value" :text="task.text" v-for="(task,index) in moduleTasks" />
        </vs-select>
      </div>
    </div>
    <div class="vx-row pb-3" v-if="$siteTypeId() != 1">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <div v-if="!isCourseReadOnly">
            <label>Prerequisite Module</label>
            <v-select ref="prereqModuleDropdown" class="w-full style-chooser" placeholder="Search / Select Module" :options="modules" v-model="prereqModuleDropdown"></v-select>
          </div>
          <div v-else>
            <label>Prerequisite Module</label>
            <vs-input autocomplete="off" :disabled="isCourseReadOnly" class="w-full" v-model="moduleData.prerequisiteModuleName" />
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row pb-3" v-if="$siteTypeId() != 1">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <div v-if="!isCourseReadOnly">
            <label>Alternative Prerequisite Module</label>
            <v-select ref="prereqModuleDropdown2" class="w-full style-chooser" placeholder="Search / Select Module" :options="modules" v-model="prereqModuleDropdown2"></v-select>
          </div>
          <div v-else>
            <label>Alternative Prerequisite Module</label>
            <vs-input autocomplete="off" :disabled="isCourseReadOnly" class="w-full" v-model="moduleData.prerequisiteModuleName2" />
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row pb-4 pt-2" v-if="$siteTypeId() != 1">
      <div class="vx-col w-1/2">
        <div class="vx-col w-3/4 info-next-to-checkcss">
          <vs-checkbox 
          v-model="moduleData.requireSignature" 
          :disabled="isCourseReadOnly"
          >Signature Required
          </vs-checkbox>
          <vx-tooltip 
            text='Students require a signature to access the module.' 
            position="bottom"
            class="info-icon-on-module" 
            delay=".3s">
              <feather-icon
                svgClasses="h-6 w-6"
                class="p-2 cursor-pointer"
                icon="InfoIcon"
              ></feather-icon>
          </vx-tooltip>
        </div>
        <div class="vx-col w-1/4">
          
        </div>
      </div>
      <div class="vx-col w-1/2">
        <div class=" vx-col w-3/4 info-next-to-checkcss">
          <vs-checkbox v-model="moduleData.allowContinuousAssessment" :disabled="isCourseReadOnly" >Allow Continuous Assessment</vs-checkbox>
          <vx-tooltip 
            text='This ignores the block between formative and summative tasks on the module, this cannot be changed after the module is created.' 
            position="bottom"
            class="info-icon-on-module" 
            delay=".3s">
              <feather-icon
                svgClasses="h-6 w-6"
                class="p-2 cursor-pointer"
                icon="InfoIcon"
              ></feather-icon>
          </vx-tooltip>
        </div>
      </div>
    </div>
    <div v-if="$siteTypeId() != 1">
      <div class="vx-row pb-4">
        <div class="vx-col sm:w-1/2 w-full info-next-to-checkcss">
          <vs-checkbox v-model="moduleData.captureTimeForAssessments" 
            @click="setDefaultHoursValue" 
            :disabled="isCourseReadOnly" >Capture Time on Assessments
          </vs-checkbox>
          <vx-tooltip 
            text='Students need to capture their times on Quiz Tasks, Video Capture Tasks, Video Quiz Tasks, and Upload Tasks. The Hours Required is divided between the tasks.'
            position="bottom"
            class="info-icon-on-module" 
            delay=".3s">
              <feather-icon
                svgClasses="h-6 w-6"
                class="p-2 cursor-pointer"
                icon="InfoIcon"
              ></feather-icon>
          </vx-tooltip>
        </div>
        <div v-if="$getSiteId() == 35" class="vx-col sm:w-1/2 w-full info-next-to-checkcss">
          <vs-checkbox v-model="moduleData.logActivity"
            :disabled="isCourseReadOnly" >Log LP Activity
          </vs-checkbox>
          <vx-tooltip 
            text='Check this if students are required to capture their times when they are done with a LP'
            position="bottom"
            class="info-icon-on-module" 
            delay=".3s">
              <feather-icon
                svgClasses="h-6 w-6"
                class="p-2 cursor-pointer"
                icon="InfoIcon"
              ></feather-icon>
          </vx-tooltip>
        </div>
      </div>
      <div class="vx-row pb-2 pl-1">
        <div class="vx-col sm:w-1/4 w-full" v-show="moduleData.captureTimeForAssessments">
          <label>Formative Hours Required</label>
          <div class="modulespinbuttonwidth">
            <vs-input-number class="numberinput" onClick="this.select();" v-model="moduleData.formativeHoursRequired" min="1" />
          </div>
        </div>
        <div class="vx-col sm:w-1/4 w-full" v-show="moduleData.captureTimeForAssessments">
          <label>Summative Hours Required</label>
          <div class="modulespinbuttonwidth">
            <vs-input-number class="numberinput" onClick="this.select();" v-model="moduleData.summativeHoursRequired" min="1" />
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row pb-2">
      <div class="vx-col sm:w-1/4 w-full">
        <label>Price</label>
        <vs-input autocomplete="off" :disabled="isCourseReadOnly" onClick="this.select();" class="w-full" v-validate="{regex: '^[0-9]{1,6}([,.]{1}[0-9]{1,2})?$'}" name="Price" v-model="moduleData.price" />
        <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
      </div>
    </div>
    <div v-show="!isCourseReadOnly">
      <div class="vx-row" v-if="!moduleData.learningStyleB">
        <div class="vx-col w-full">
          <vs-divider>Milestones</vs-divider>
        </div>
      </div>
      <div v-if="!moduleData.learningStyleB"> 
        <ul>
          <li v-for="(milestone, index) in moduleData.milestones" :key="index">
            <div id="milestones-row" class="vx-row mb-4">
              <div class="vx-col flex-1">
                <label>Task</label>
                <vs-select v-validate="'required'" name="Task" placeholder="Search / Select Task" class="w-full vs-con-loading__container" vs-multiple autocomplete v-model="milestone.taskId">
                  <vs-select-item :key="index" :value="task.value" :text="task.text" v-for="(task,index) in moduleTasks" />
                </vs-select>
              </div>
              <div class="vx-col flex-1">
                <label>Days</label>
                <vs-input  autocomplete="off" onClick="this.select();" class="w-full"  v-validate="'required'" name="Days" v-model="milestone.days" />
                <span class="text-danger text-sm" v-show="errors.has('Days')">{{ errors.first('Days') }}</span>
              </div>
              <div class="vx-col flex-1">
                <label>Coins</label>
                <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Coins" v-model="milestone.coins" />
                <span class="text-danger text-sm" v-show="errors.has('Coins')">{{ errors.first('Coins') }}</span>
              </div>

              <div class="vx-col w-1/10">
                <label>Is Visible</label>
                <vs-checkbox color="success" v-model="milestone.isVisible" />
              </div>

              <div id="delete-column" class="vx-col w-1/6">
                <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="deleteMilestone(index)"></vs-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="!moduleData.learningStyleB">
        <vs-button ref="choicesAdd" class="w-full cursor-pointer mb-4" type="border" color="success" icon-pack="feather" icon="icon-plus" @click="addMilestones"></vs-button>
      </div>
    </div>
    <div v-show="moduleData.id">
      <div v-if="$siteTypeId() != 1">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-divider>Module Documents</vs-divider>
          </div>
        </div>
        <vs-collapse class="border">
          <vs-collapse-item>
            <div slot="header">
              Module Documents
            </div>
            <div class="vx-col w-full">
              <div class="flex flex-wrap vs-con-loading__container items-center justify-center mt-8">
                <v-uploader @done="successUpload" button-text="Upload Files" ref="fileUpload" fileTypeExts="mp3,pdf,doc,docx,xls,xlsx,ppt,pptx,txt,rtf,png,jpg,jpeg,gif,mp4,mov,wmv" language="en" :multiple="false" file-size-limit="100MB" :preview="false"></v-uploader>
              </div>
              <div>
                <vs-table ref="uploadsTable" single max-items="5" @selected="open" pagination :data="documents">
                  <template slot-scope="{data}">
                    <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
                      <vs-td>
                        <img :src="setFileThumb(file.url)" width=30px class="product-img" />
                      </vs-td>
                      <vs-td>
                        <p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1) }}</p>
                      </vs-td>
                      <vs-td>
                        <vs-button v-if="file.documentTypeId != 9" color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop.prevent="removeDoc(file.id)"></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Students</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!assignedStudents">
              <div slot="header">
                View Assigned/Ready-to-Assign Students
              </div>
              <div id="studentList">
                <div>
                  <vs-button icon-pack="feather" @click.stop.prevent="populateStudents()">Load Students</vs-button>
                </div>
                <vs-table ref="allStudentsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="allStudents">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="studentFullName">Name</vs-th>
                    <vs-th sort-key="studentMobile">Mobile Number</vs-th>
                    <vs-th sort-key="studentIdNumber">ID Number</vs-th>
                    <vs-th sort-key="studentEmail">Email</vs-th>
                    <vs-th sort-key="companyName">{{ $siteTypeId() == 1 ? 'Classroom' : 'Company' }}</vs-th>
                    <vs-th>Assign</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="allStudents" :state="allStudents.isActive == false ? 'warning' : null" :key="indextr" v-for="(student, indextr) in data">

                      <vs-td :data="data[indextr].studentFullName">
                        {{ student.studentFullName}}
                      </vs-td>

                      <vs-td :data="data[indextr].studentMobile">
                        {{ student.studentMobile }}
                      </vs-td>

                      <vs-td :data="data[indextr].studentIdNumber">
                        {{ student.studentIdNumber }}
                      </vs-td>

                      <vs-td :data="data[indextr].studentEmail">
                        {{ student.studentEmail }}
                      </vs-td>

                      <vs-td :data="data[indextr].companyName">
                        {{ student.companyName ? student.companyName : "N/A" }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignStudent(student.studentId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div id="AssignTable">
                <vs-table style="height: max-content;" ref="assignedStudentsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedStudents">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                    <div>
                      <vs-checkbox v-model="showInactiveStudents" color="warning">Show Inactive Students</vs-checkbox>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="studentFullName">Name</vs-th>
                    <vs-th sort-key="studentIdNumber">ID Number</vs-th>
                    <vs-th sort-key="studentEmail">Email Address</vs-th>
                    <vs-th sort-key="studentMobile">Mobile Number</vs-th>
                    <vs-th sort-key="companyName">{{ $siteTypeId() == 1 ? 'Classroom' : 'Company' }}</vs-th>
                    <vs-th>Options</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assignedStudents" :state="assignedStudents.isActive == false ? 'warning' : null" :key="indextr" v-for="(student, indextr) in data">

                      <vs-td :data="data[indextr].studentFullName">
                        {{ student.studentFullName }}
                      </vs-td>

                      <vs-td :data="data[indextr].studentIdNumber">
                        {{ student.studentIdNumber }}
                      </vs-td>

                      <vs-td :data="data[indextr].studentEmail">
                        {{ student.studentEmail }}
                      </vs-td>

                      <vs-td :data="data[indextr].studentMobile">
                        {{ student.studentMobile }}
                      </vs-td>

                      <vs-td :data="data[indextr].companyName">
                        {{ student.companyName ? student.companyName : "N/A" }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="warning" type="flat" icon-pack="feather" icon="icon-sliders" @click.stop.prevent="showStudentModuleOptionsPopUp(student.studentId,moduleData.id)"></vs-button>
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignStudent(student.studentId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="true">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Tasks</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!tasks">
              <div slot="header">
                View Tasks For This {{ $siteTypeId() == 1 ? 'Topic' : 'Module' }}
              </div>
              <div id="TasksTable">
                <vs-table ref="tasksTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="tasks">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Tasks for this Module</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="displayId">Display Name</vs-th>
                    <vs-th sort-key="typeName">Type</vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="isCoinsRecurring">Coins Recurring?</vs-th>
                    <vs-th sort-key="coinValue">Coin Value</vs-th>
                    <vs-th sort-key="modifiedOn">Modified On</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tasks" :key="indextr" v-for="(task, indextr) in data">

                      <vs-td :data="data[indextr].displayId">
                        {{ task.displayId }}
                      </vs-td>

                      <vs-td :data="data[indextr].typeName">
                        {{ task.typeName }}
                      </vs-td>

                      <vs-td :data="data[indextr].name">
                        {{ task.name }}
                      </vs-td>

                      <vs-td :data="data[indextr].isCoinsRecurring">
                        {{ task.isCoinsRecurring == null || task.isCoinsRecurring == false ? 'No' : 'Yes' }}
                      </vs-td>

                      <vs-td :data="data[indextr].coinValue">
                        {{ task.coinValue == null ? 'N/A' : task.coinValue }}
                      </vs-td>

                      <vs-td :data="data[indextr].modifiedOn">
                        {{ task.modifiedOn.replace("T", " ").split('.')[0] }}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Assessors</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!assessors">
              <div slot="header">
                View Assigned/Ready-to-Assign Assessors
              </div>
              <div id="AssignTable">
                <vs-table ref="assessorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assessors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assessors" :key="indextr" v-for="(assessor, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ assessor.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ assessor.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignAssessor(assessor.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div id="AssignTable">
                <vs-table ref="assignedAssessorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedAssessors">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assessors" :key="indextr" v-for="(assessor, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ assessor.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ assessor.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignAssessor(assessor.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Moderators</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!moderators">
              <div slot="header">
                View Assigned/Ready-to-Assign Moderators
              </div>
              <div id="AssignTable">
                <vs-table ref="moderatorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="moderators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="moderators" :key="indextr" v-for="(moderator, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ moderator.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ moderator.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignModerator(moderator.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div id="AssignTable">
                <vs-table ref="assignedModeratorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedModerators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="moderators" :key="indextr" v-for="(moderator, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ moderator.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ moderator.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignModerator(moderator.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Evaluators</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item :disabled="!evaluators">
              <div slot="header">
                View Assigned/Ready-to-Assign Evaluators
              </div>
              <div id="AssignTable">
                <vs-table ref="evaluatorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="evaluators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready-to-Assign</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="evaluators" :key="indextr" v-for="(evaluator, indextr) in data">

                      <vs-td :data="data[indextr].userFirstName">
                        {{ evaluator.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ evaluator.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignEvaluator(evaluator.id)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div id="AssignTable">
                <vs-table ref="assignedEvaluatorsTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedEvaluators">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Already Assigned</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="firstName">Name</vs-th>
                    <vs-th sort-key="lastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="evaluators" :key="indextr" v-for="(evaluator, indextr) in data">

                      <vs-td :data="data[indextr].firstName">
                        {{ evaluator.firstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].lastName">
                        {{ evaluator.lastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignEvaluator(evaluator.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
        <div v-if="$acl.check('MaintainUsers')">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Mentors</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item>
              <div slot="header">
                View Assigned/Ready-to-Assign Mentors
              </div>
              <div id="AssignTable">
                <v-select ref="mentorsDropdown" placeholder="Search / Select Mentor to Assign" :options="unassignedMentors" @search:blur="assignMentor" v-model="mentorsDropdown"></v-select>
                <vs-table id="mentorsTable" ref="mentorsTable" class="vs-con-loading__container" single pagination max-items="10" search :data="assignedMentors">
                  <template slot="thead">
                    <vs-th sort-key="userFirstName">Name</vs-th>
                    <vs-th sort-key="userLastName">Surname</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="assignedMentors" :key="indextr" v-for="(mentor, indextr) in data" >

                      <vs-td :data="data[indextr].userFirstName">
                        {{ mentor.userFirstName }}
                      </vs-td>

                      <vs-td :data="data[indextr].userLastName">
                        {{ mentor.userLastName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignMentor(mentor.userId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
        <div v-if="$acl.check('MaintainUsers') && !isCourseReadOnly">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Sharing</vs-divider>
            </div>
          </div>
          <vs-collapse class="border">
            <vs-collapse-item>
              <div slot="header">
                Manage Module Sharing
              </div>
              <div id="AssignTable">
                <vs-table ref="sitesTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="sites">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Ready to Share</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="companyName">Site Name</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="sites" :key="indextr" v-for="(site, indextr) in data">

                      <vs-td :data="data[indextr].companyName">
                        {{ site.companyName }}
                      </vs-td>

                      <vs-td>
                        <div class="flex float-right">
                          <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="shareWithSite(site.id)">Read-only Copy</vs-button>
                          <!-- <vs-button color="warning" type="flat" icon-pack="feather" icon="icon-copy" @click.stop.prevent="showSelectCoursePopup(site.id)">Full Clone</vs-button> -->
                        </div>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <vs-divider></vs-divider>
              <div id="AssignTable">
                <vs-table ref="sharedSitesTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="sitesSharedWith">
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                      <h3 class="ml-2">Sites Already Shared With</h3>
                    </div>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="siteName">Site Name</vs-th>
                    <vs-th></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="sitesSharedWith" :key="indextr" v-for="(site, indextr) in data">

                      <vs-td :data="data[indextr].siteName">
                        {{ site.siteName }}
                      </vs-td>

                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="removeShare(site.siteId)"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>

    </div>

    <div v-show="!isCourseReadOnly" class="vx-row mt-4" style="margin-left: 0px;">
      <!-- <div class="vx-col"> -->
      <vs-button v-if="$siteTypeId() == 1" color="success" icon-pack="feather" icon="icon-check" class="mr-3 mb-2 vs-con-loading__container" ref="completeModuleButton" :disabled="!moduleData.startTaskId || moduleData.isModuleComplete" @click="completeModule">{{ moduleData.isModuleComplete ? 'Topic Completed' : 'Complete Topic' }}</vs-button>
      <vs-button v-else color="success" icon-pack="feather" icon="icon-check" class="mr-3 mb-2 vs-con-loading__container" ref="completeModuleButton" :disabled="!moduleData.startTaskId || moduleData.isModuleComplete" @click="completeModule">{{ moduleData.isModuleComplete ? 'Module Completed' : 'Complete Module' }}</vs-button>
      <vs-button v-if="$siteTypeId() == 1" color="primary" icon-pack="feather" icon="icon-copy" class="mr-3 mb-2 vs-con-loading__container" ref="cloneModuleButton" :disabled="!moduleData.id" @click="showCloneModulePart">Clone Topic</vs-button>
      <vs-button v-else color="primary" icon-pack="feather" icon="icon-copy" class="mr-3 mb-2 vs-con-loading__container" ref="cloneModuleButton" :disabled="!moduleData.id" @click="showCloneModulePart">Clone Module</vs-button>
      <!-- </div> -->
      <vs-spacer></vs-spacer>
      <div class="vx-col" style="padding-left: 0 !important;">
        <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" ref="saveModuleButton" :disabled="saveButtonDisabled" @click="saveEditModule">Save</vs-button>
        <vs-button color="danger" v-show="moduleData.id" class="mr-5 mb-2 vs-con-loading__container" @click="showDeletePopUp" ref="deleteModuleButton">Delete</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="isCardActiveLocal = false">Cancel</vs-button>
      </div>
    </div>
    <div v-show="isCourseReadOnly" class="vx-row mt-4" style="margin-left: 0px;">
      <vs-spacer></vs-spacer>
      <div class="vx-col" style="padding-left: 0 !important;">
        <vs-button color="warning" type="border" class="mb-2" @click="isCardActiveLocal = false">Close</vs-button>
      </div>
    </div>
    <div v-show="clonePrompt">
      <vs-divider></vs-divider>
      <vx-card class="mt-4">
        <vs-button size="small" id="top-right-close" radius color="danger" type="flat" icon-pack="feather" icon="icon-x" @click="cancelClone"></vs-button>
        <div>
          <label>Clone {{ $siteTypeId() == 1 ? 'topic' : 'module' }} to:</label>
          <v-select class="mt-1 style-chooser" :placeholder="$siteTypeId() == 1 ? 'Search / Select Subject' : 'Search / Select Course'" :options="courses" v-model="courseDropdown"></v-select>
        </div>
        <div class="mt-2">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" ref="cloneButton" :disabled="!courseDropdown" @click="cloneModule">Clone</vs-button>
        </div>
      </vx-card>
    </div>

    <vs-popup title="Having some problems?" :active.sync="coursePopupActive">
      
      <div class="mt-3">
        <vs-button color="success" class="float-right" >Submit</vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select';
  import uploaderSidebar from './DocUploadSidebar.vue';

  import 'animate.css';
  export default {
    components: {
      'v-select': vSelect,
      uploaderSidebar
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      moduleSelected: {
        type: Object,
        required: false
      },
      sourceCourseId: {
        type: Number,
        required: false
      },
      moduleCardTitle: {
        type: String,
        required: false
      },
      isCourseReadOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        loadingColor:'#fff',
        moduleData: {
          id: 0,
          courseId: 0,
          name: "",
          description: "",
          coinCount: "",
          milestones: [],
          startTaskId: "",
          endTaskId: "",
          isModuleComplete: false,
          price: 0,
          moduleCategoryId: null,
          moduleGroupId: null,
          moduleCategoryName: "",
          moduleGroupName: "",
          prerequisiteModuleId: null,
          prerequisiteModuleName: "",
          prerequisiteModuleId2: null,
          prerequisiteModuleNam2: "",
          backActive: false,
          learningStyleB: false,
          requireSignature: false,
          allowContinuousAssessment: false,
          forTrimmedDownCurriculum: false,
          captureTimeForAssessments: false,
          formativeHoursRequired: null,
          summativeHoursRequired: null,
          saqaId:"",
          nqfLevel:"",
          credits:0,
          logActivity: false
        },
        ignorePrerequisite: false,
        classificationDropdown: 0,
        moduleTasks: [],
        mode: "",
        allStudents: [],
        assignedStudents: [],
        showInactiveStudents: false,
        clonePrompt: false,
        courseDropdown: 0,
        moduleDropdown: 0,
        courses: [],
        modules: [],
        tasks: [],
        assessors: [],
        showInactiveAssessors: false,
        assignedAssessors: [],
        moderators: [],
        showInactiveModerators: false,
        assignedModerators: [],
        evaluators: [],
        showInactiveEvaluators: false,
        assignedEvaluators: [],
        categoryDropdown: 0,
        categories: [],
        groupDropdown: 0,
        groups: [],
        sites: [],
        sitesSharedWith: [],
        uploadedFiles: [],
        sidebarActive: false,
        documents: [],
        prereqModuleDropdown: 0,
        prereqModuleDropdown2: 0,
        mentorsDropdown: 0,
        assignedMentors: [],
        unassignedMentors: [],
        coursePopupActive: false,
        siteToShare: null,
        siteCourses: [],
        siteCourseDropdown: 0
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
      saveButtonDisabled: function() {
        var self = this;
        var disabledButton = false;
        if(self.moduleData.milestones){
          self.moduleData.milestones.forEach(element => {
            if((element.days.toString() =="") || (element.coins.toString() =="")){
              disabledButton = true;
            }
          });
        }
        if(!this.moduleData.name){
          disabledButton = true;
        }
        return disabledButton;
      },
    },
    watch: {
      isCardActive: function(val) {
        var self = this;
        self.initValues();
        if(val){
          var self = this;

          if (self.moduleSelected.id) {
            self.mode = "Edit";
            self.moduleData.id = self.moduleSelected.id;
            self.moduleData.courseId = self.sourceCourseId;
            self.moduleData.name = self.moduleSelected.name;
            self.moduleData.description = self.moduleSelected.description;
            self.moduleData.coinCount = self.moduleSelected.coinCount;
            self.moduleData.milestones = self.moduleSelected.milestones;
            self.moduleData.startTaskId = self.moduleSelected.startTaskId;
            self.moduleData.endTaskId = self.moduleSelected.endTaskId;
            self.moduleData.isModuleComplete = self.moduleSelected.isModuleComplete;
            self.moduleData.price = self.moduleSelected.price;
            self.moduleData.moduleCategoryName = self.moduleSelected.moduleCategoryName;
            self.moduleData.moduleGroupName = self.moduleSelected.moduleGroupName;
            self.moduleData.prerequisiteModuleName = self.moduleSelected.prerequisiteModuleName;
            self.moduleData.prerequisiteModuleName2 = self.moduleSelected.prerequisiteModuleName2;
            self.moduleData.backActive = self.moduleSelected.backActive;
            self.moduleData.allowContinuousAssessment = self.moduleSelected.allowContinuousAssessment;
            self.moduleData.learningStyleB = self.moduleSelected.learningStyleB;
            self.moduleData.requireSignature = self.moduleSelected.requireSignature;
            self.moduleData.forTrimmedDownCurriculum = self.moduleSelected.forTrimmedDownCurriculum;
            self.moduleData.saqaId = self.moduleSelected.saqaId;
            self.moduleData.credits = self.moduleSelected.credits;
            self.moduleData.nqfLevel = self.moduleSelected.nqfLevel;

            self.moduleData.captureTimeForAssessments = self.moduleSelected.captureTimeForAssessments;
            self.moduleData.formativeHoursRequired = self.moduleSelected.formativeHoursRequired;
            self.moduleData.summativeHoursRequired = self.moduleSelected.summativeHoursRequired;

            self.moduleData.logActivity = self.moduleSelected.logActivity;

            self.getCategories(function() {
              self.categoryDropdown = self.categories.filter(function(item){return item.value == self.moduleSelected.moduleCategoryId;})[0];
            });
            self.getGroups(function() {
              self.groupDropdown = self.groups.filter(function(item){return item.value == self.moduleSelected.moduleGroupId;})[0];
            });
            self.getModules(function() {
              self.prereqModuleDropdown = self.modules.filter(function(item){return item.value == self.moduleSelected.prerequisiteModuleId;})[0];
              self.prereqModuleDropdown2 = self.modules.filter(function(item){return item.value == self.moduleSelected.prerequisiteModuleId2;})[0];
            });
            self.getTasksSelectList(self.moduleSelected.id);
            
            if (self.$siteTypeId() != 1) {
              self.listDocuments(self.moduleData.id);
              self.listTasks(self.moduleSelected.id);
            }

            if(self.$acl.check("MaintainUsers") && self.$siteTypeId() != 1) {
              self.getAllAssessors(self.moduleSelected.id);
              self.getAssignedAssessors(false);
              self.getAllModerators(self.moduleSelected.id);
              self.getAssignedModerators(false);
              self.getAllEvaluators(self.moduleSelected.id);
              self.getAssignedEvaluators(false);
              self.getUnassignedMentors(self.moduleSelected.id);
              self.getAssignedMentors();
              if(!self.isCourseReadOnly) {
                self.getAllSites();
                self.getSharedSites();
              }
            }
          }else{
            self.initValues();
            self.getCategories();
            self.getGroups();
            self.getModules();
            self.mode = "Add";
          }
        }else{
          this.$emit('loadModules');
        }
      },
      showInactiveStudents: function(val) {
        this.getAssignedStudents(val);
      },
      showInactiveAssessors: function(val) {
        this.getAssignedAssessors(val);
      },
      showInactiveModerators: function(val) {
        this.getAssignedModerators(val);
      },
      showInactiveEvaluators: function (val) {
        this.getAssignedEvaluators(val);
      },
    },
    methods: {
      getCourses() {
        var self = this;
        var onSuccess = response => {
          self.courses = response.data.map((item) => {return {label: item.text, value: item.value} });
          self.courseDropdown = self.courses.filter(function (item) { return item.value == self.moduleData.courseId; })[0];
        };
        self.$ajaxGet(self, "Course/GetSelectList", onSuccess);
      },
      getCategories(whenDone) {
        var self = this;
        var onSuccess = response => {
          self.categories = response.data.map((item) => {return {label: item.text, value: item.value} });
          if (whenDone && typeof whenDone == "function")
            whenDone();
        };
        self.$ajaxGet(self, "ModuleCategory/GetSelectList/" + self.sourceCourseId, onSuccess);
      },
      getGroups(whenDone) {
        var self = this;
        var onSuccess = response => {
          self.groups = response.data.map((item) => {return {label: item.text, value: item.value} });
          if (whenDone && typeof whenDone == "function")
            whenDone();
        };
        self.$ajaxGet(self, "ModuleGroup/GetSelectList", onSuccess);
      },
      getModules(whenDone) {
        var self = this;
        var onSuccess = response => {
          self.modules = response.data.map((item) => {return {label: item.text, value: item.value} });
          if (self.moduleData.id) {
            self.modules = self.modules.filter(x => { return x.value != self.moduleSelected.id });
          }
          if (whenDone && typeof whenDone == "function")
            whenDone();
        };
        self.$ajaxGet(self, "Module/GetCompleteModulesList", onSuccess);
      },
      getTasksSelectList(moduleId){
        var self = this;
        var onSuccess = response => { 
          self.moduleTasks = response.data;
        };
        self.$ajaxGet(self, "Module/getTasksSelectList?moduleId=" + moduleId, onSuccess);
      },
      listTasks(moduleId) {
        const self = this;
        self.showLoadingOnElement("tasksTable", 1, "corners");

        var onSuccess = function (response) {
          self.tasks = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.tasksTable.$el);
          self.$refs.tasksTable.searchx = "";
        };

        self.$ajaxGet(self, "Module/ListTasks?moduleId=" + moduleId, onSuccess, onFinally);
      },
      listDocuments(moduleId) {
        const self = this;
        self.showLoadingOnElement("uploadsTable", 1, "corners");

        var onSuccess = function (response) {
          self.documents = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.uploadsTable.$el);
          self.$refs.uploadsTable.searchx = "";
        };

        self.$ajaxGet(self, "Module/ListDocuments?moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      saveData() {
        this.$emit('saveData', this.mode);
      },
      successUpload(data) {
        var self = this;
        self.showLoadingOnElement("uploadsTable", 1, "corners");
        self.sidebarActive = false;
        var fileUrl = data[0].url;

        var onSuccess = response => {
          self.listDocuments(self.moduleData.id);
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Document Uploaded",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
        };

        var onFinally = function() {
          self.$vs.loading.close(self.$refs.uploadsTable.$el);
        };
        var formData = {
          moduleId: self.moduleData.id,
          documentTypeId: 1,
          url: fileUrl
        }
        
        self.$ajaxPost(self, "Module/AddDoc", formData, onSuccess, onFinally);
      },
      open(file){
        window.open(file.url);
      },
      completeModule() {
        var self = this;
        self.showLoadingOnElement("completeModuleButton", 0.45, "material");

        this.$validator.validateAll().then(result => {
          var self = this;
          if (result) {
            self.moduleData.courseId = self.sourceCourseId;
            self.moduleData.coinCount = isNaN(parseInt(self.moduleData.coinCount)) ? null : parseInt(self.moduleData.coinCount);
            self.moduleData.price = isNaN(parseInt(self.moduleData.price)) ? 0 : parseInt(self.moduleData.price);
            self.moduleData.moduleCategoryId = self.categoryDropdown ? parseInt(self.categoryDropdown.value) : null;
            self.moduleData.moduleGroupId = self.groupDropdown ? parseInt(self.groupDropdown.value) : null;
            self.moduleData.prerequisiteModuleId = self.prereqModuleDropdown ? parseInt(self.prereqModuleDropdown.value) : null;
            self.moduleData.prerequisiteModuleId2 = self.prereqModuleDropdown2 ? parseInt(self.prereqModuleDropdown2.value) : null;

            var onSaveSuccess = response => {
              self.moduleData.id = response.data;

              var onSuccess = response => {
                self.initValues();
                self.saveData();
                self.mode = "Edit";
                self.$vs.notify({
                  title:'Information',
                  color: "success",
                  text: `${self.$siteTypeId() == 1 ? 'Topic' : 'Module'} Saved`,
                  position:'top-right',
                  iconPack: 'feather',
                  icon:'icon-save'
                });
              };
              var onFinally = function () {
                self.$vs.loading.close(self.$refs.completeModuleButton.$el);
              };
              
              self.$ajaxGet(self, "module/CompleteModule/" + self.moduleData.id, onSuccess, onFinally);
            };
            
            var onSaveFinally = function () {
              self.$vs.loading.close(self.$refs.completeModuleButton.$el);
            };
            
            self.$ajaxPost(self, "module/addeditmodule", self.moduleData, onSaveSuccess, onSaveFinally);
          }else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      cancelClone() {
        this.clonePrompt = false;
        this.courseDropdown = 0;
      },
      showCloneModulePart() {
        this.clonePrompt = true;
        this.scrollToFooter();
        this.getCourses();
      },
      cloneModule() {
        var self = this;
        self.clonePrompt = false;
        self.showLoadingOnElement("cloneModuleButton", 0.45, "material");
        
        var onSuccess = response => {
          self.getTasksSelectList(response.data.id);
          self.moduleData = response.data;
          self.mode = "Edit";
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `${self.$siteTypeId() == 1 ? 'Topic' : 'Module'} Cloned`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.cloneModuleButton.$el);
        };
        
        self.$ajaxGet(self, `module/CloneModule?courseId=${self.courseDropdown.value}&moduleId=${self.moduleData.id}&styleB=${self.moduleData.learningStyleB}`, onSuccess, onFinally);
      },
      saveEditModule() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("saveModuleButton", 0.45, "material");
            self.moduleData.courseId = self.sourceCourseId;
            self.moduleData.coinCount = isNaN(parseInt(self.moduleData.coinCount)) ? null : parseInt(self.moduleData.coinCount);
            self.moduleData.price = isNaN(parseInt(self.moduleData.price)) ? 0 : parseInt(self.moduleData.price);
            self.moduleData.moduleCategoryId = self.categoryDropdown ? parseInt(self.categoryDropdown.value) : null;
            self.moduleData.moduleGroupId = self.groupDropdown ? parseInt(self.groupDropdown.value) : null;
            self.moduleData.prerequisiteModuleId = self.prereqModuleDropdown ? parseInt(self.prereqModuleDropdown.value) : null;
            self.moduleData.prerequisiteModuleId2 = self.prereqModuleDropdown2 ? parseInt(self.prereqModuleDropdown2.value) : null;
            
            var onSuccess = response => {
              self.moduleData.id = response.data;
              if(self.mode == "Add"){
                if (self.$siteTypeId() != 1) {
                  self.getTasksSelectList(self.moduleData.id);
                  self.listTasks(self.moduleData.id);
                  self.listDocuments(self.moduleData.id);
                  if(self.$acl.check('MaintainUsers')) {
                  
                    self.getAllAssessors(self.moduleData.id);
                    self.getAssignedAssessors(false);
                    self.getAllModerators(self.moduleData.id);
                    self.getAssignedModerators(false);
                    self.getAllEvaluators(self.moduleData.id);
                    self.getAssignedEvaluators(false);
                    self.getUnassignedMentors(self.moduleData.id);
                    self.getAssignedMentors();
                  }
                }
                self.scrollToFooter();
              }
              else{
                self.initValues();
              }
              self.saveData();
              self.mode = "Edit";
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: `${self.$siteTypeId() == 1 ? 'Topic' : 'Module'} Saved`,
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveModuleButton.$el);
            };
            
            self.$ajaxPost(self, "module/addeditmodule", self.moduleData, onSuccess, onFinally);
          }else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      addMilestones() {
        var self = this;
        self.moduleData.milestones.push({
          id: 0,
          moduleId: self.moduleData.id,
          taskId: "",
          days: "",
          coins: ""
        });
      },
      deleteMilestone(index) {
        this.moduleData.milestones.splice(index,1)
      },
      showDeletePopUp(){
        var self = this;
        self.$swal({
          title: 'Are you sure you want to delete' + " " + '<strong>' + self.moduleData.name + '</strong>',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: `Cancel`,
          confirmButtonText: 'Yes Delete',
          confirmButtonColor: '#d33',
        }).then((result) => {
          if (result.isConfirmed) {
            self.deleteModule();
          }
        });
      },
      deleteModule() {
        var self = this;
        self.showLoadingOnElement("deleteModuleButton", 0.45, "material");

        var onSuccess = response => {
          self.saveData();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `${self.$siteTypeId() == 1 ? 'Topic' : 'Module'} Deleted`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteModuleButton.$el);
        };

        self.$ajaxDelete(self, "Module/DeleteModule/" + self.moduleData.id, onSuccess, onFinally);
      },
      initValues() {
        this.moduleData.id = 0;
        this.moduleData.name = "";
        this.moduleData.description = "";
        this.moduleData.coinCount = "";
        this.moduleData.milestones = [];
        this.moduleData.startTaskId = "";
        this.moduleData.endTaskId = "";
        this.moduleData.isModuleComplete = false;
        this.moduleData.price = 0;
        this.moduleData.moduleCategoryId = null;
        this.moduleData.moduleGroupId = null;
        this.moduleData.prerequisiteModuleId = null;
        this.moduleData.prerequisiteModuleId2 = null;
        this.moduleData.backActive = false;
        this.moduleData.allowContinuousAssessment = false;
        this.moduleData.learningStyleB = false;
        this.moduleData.requireSignature = false;
        this.moduleData.forTrimmedDownCurriculum = false;
        this.moduleData.isPremium = false;
        this.moduleData.captureTimeForAssessments = false;
        this.moduleData.formativeHoursRequired = null;
        this.moduleData.summativeHoursRequired = null;
        this.moduleData.logActivity = false;
        this.moduleData.saqaId = "";
        this.moduleData.credits = 0;
        this.moduleData.nqfLevel = "";
        this.mode = "";
        this.moduleTasks = [];
        this.clonePrompt = false;
        this.courseDropdown = 0;
        this.categoryDropdown = 0;
        this.groupDropdown = 0;
        this.sites = [];
        this.sitesSharedWith = [];
        this.allStudents = [];
        this.assignedStudents = [];
        this.errors.clear();
      },
      populateStudents() {
        this.getAllStudents(this.moduleData.id);
        this.getAssignedStudents(false);
      },
      getAllStudents(moduleId) {
        const self = this;
        self.showLoadingOnElement("allStudentsTable", 1, "corners");

        var onSuccess = function (response) {
          
          self.allStudents = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.allStudentsTable.$el);
          self.$refs.allStudentsTable.searchx = "";
        };

        self.$ajaxGet(self, "StudentModule/GetAllStudents?moduleId=" + moduleId, onSuccess, onFinally);
      },
      getAssignedStudents(val) {
        const self = this;
        self.showLoadingOnElement("assignedStudentsTable", 1, "corners");

        var onSuccess = function (response) {
          self.assignedStudents = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedStudentsTable.$el);
          self.$refs.assignedStudentsTable.searchx = "";
        };

        self.$ajaxGet(self, "StudentModule/ListModuleAssignedStudents?showInactive=" + val + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      assignStudent(studentId) {
        var self = this;

        if(!self.moduleData.isModuleComplete){
          self.$vs.dialog({
            color: 'warning',
            title: 'Information',
            text: 'Please mark the module as "Completed" before trying to assign any students.',
            acceptText: 'OK'
          })
          return;
        }

        self.showLoadingOnElement("allStudentsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Student Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.allStudentsTable.$el);
          self.getAllStudents(self.moduleData.id);
          self.getAssignedStudents(self.showInactiveStudents);
        };

        self.$ajaxGet(self, "StudentModule/AssignToModule?studentId=" + studentId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      unassignStudent(studentId) {
        var self = this;
        self.showLoadingOnElement("assignedStudentsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Student Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedStudentsTable.$el);
          self.getAllStudents(self.moduleData.id);
          self.getAssignedStudents(self.showInactiveStudents);
        };

        self.$ajaxGet(self, "StudentModule/DeactivateFromModule?studentId=" + studentId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      async showStudentModuleOptionsPopUp(studentId,moduleId){
        self = this;
        
        var onSuccess = async response => {
          var studentName = self.assignedStudents.filter(x=> x.studentId === studentId)[0].studentFullName
          var moduleName = self.moduleData.name

          const { value: formValues  } = await self.$swal.fire({
            title: '<h3>Student Module Options</h3>' + `<h4>Module: ${moduleName}</h4>` + `<h4>Student: ${studentName}</h4>`,
            html:
              `<p></p>`+
              ` <div class="pretty p-default p-round p-fill">
                  <input type="checkbox" class="check_container" id="ignorePrerequisitePopUpCheckBox" name="ignorePrerequisite" `+ (response.data.ignorePrerequisite ? "Checked" : "")+`>
                  <div class="state p-success">
                    <label for="ignorePrerequisitePopUpCheckBox"> Ignore Prerequisites</label><br>
                  </div>
                 
                </div>
              `,
            focusConfirm: false,
            showCancelButton: true,
            preConfirm: () => {
              const ignorePrerequisiteCheckBox = document.getElementById('ignorePrerequisitePopUpCheckBox')
              const ignorePrerequisiteCheckBoxValue = ignorePrerequisiteCheckBox.checked ? true : false

              return [
                ignorePrerequisiteCheckBoxValue
              ]}
          })
          if (formValues) {
            self.updateStudentModuleOptionsPost(studentId,moduleId,formValues)
          }
        };
        var onFinally = ()=>{
          self.$vs.loading.close(self.$refs.Whole_Page.$el);
        }
        self.showLoadingOnElement("Whole_Page", 1, "corners");
        self.$ajaxGet(self, "StudentModule/GetStudentModuleOptions?studentId=" + studentId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);

      },
      updateStudentModuleOptionsPost(studentId,moduleId,options){
        var objectToPost = 
          {
            studentId:studentId,
            moduleId:moduleId,
            ignorePrerequisite:options[0]
          }

        self.$ajaxPost(self, "StudentModule/UpdateStudentModuleOptions",objectToPost, ()=>{}, ()=>{});
      },
      getAllAssessors(moduleId) {
        const self = this;
        self.showLoadingOnElement("assessorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.assessors = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assessorsTable.$el);
        };

        self.$ajaxGet(self, "AssessorModule/GetAllAssessors?moduleId=" + moduleId, onSuccess, onFinally);
      },
      getAssignedAssessors(val) {
        const self = this;
        self.showLoadingOnElement("assignedAssessorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.assignedAssessors = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedAssessorsTable.$el);
          self.$refs.assignedAssessorsTable.searchx = "";
        };

        self.$ajaxGet(self, "AssessorModule/ListModuleAssignedAssessors?showInactive=" + val + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      assignAssessor(userId) {
        var self = this;
        self.showLoadingOnElement("assessorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Assessor Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assessorsTable.$el);
          self.getAllAssessors(self.moduleData.id);
          self.getAssignedAssessors(self.showInactiveAssessors);
        };

        self.$ajaxGet(self, "AssessorModule/AssignToModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      unassignAssessor(userId) {
        var self = this;
        self.showLoadingOnElement("assignedAssessorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Assessor Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedAssessorsTable.$el);
          self.getAllAssessors(self.moduleData.id);
          self.getAssignedAssessors(self.showInactiveAssessors);
        };

        self.$ajaxGet(self, "AssessorModule/DeactivateFromModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      getAllModerators(moduleId) {
        const self = this;
        self.showLoadingOnElement("moderatorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.moderators = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.moderatorsTable.$el);
          self.$refs.moderatorsTable.searchx = "";
        };

        self.$ajaxGet(self, "ModeratorModule/GetAllModerators?moduleId=" + moduleId, onSuccess, onFinally);
      },
      getAssignedModerators(val) {
        const self = this;
        self.showLoadingOnElement("assignedModeratorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.assignedModerators = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedModeratorsTable.$el);
          self.$refs.assignedModeratorsTable.searchx = "";
        };

        self.$ajaxGet(self, "ModeratorModule/ListModuleAssignedModerators?showInactive=" + val + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      assignModerator(userId) {
        var self = this;
        self.showLoadingOnElement("moderatorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Moderator Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.moderatorsTable.$el);
          self.getAllModerators(self.moduleData.id);
          self.getAssignedModerators(self.showInactiveModerators);
        };

        self.$ajaxGet(self, "ModeratorModule/AssignToModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      unassignModerator(userId) {
        var self = this;
        self.showLoadingOnElement("assignedModeratorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Moderator Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedModeratorsTable.$el);
          self.getAllModerators(self.moduleData.id);
          self.getAssignedModerators(self.showInactiveModerators);
        };

        self.$ajaxGet(self, "ModeratorModule/DeactivateFromModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      getAllEvaluators(moduleId) {
        const self = this;
        self.showLoadingOnElement("evaluatorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.evaluators = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.evaluatorsTable.$el);
          self.$refs.evaluatorsTable.searchx = "";
        };

        self.$ajaxGet(self, "EvaluatorModule/GetAllEvaluators?moduleId=" + moduleId, onSuccess, onFinally);
      },
      getAssignedEvaluators(val) {
        const self = this;
        self.showLoadingOnElement("assignedEvaluatorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.assignedEvaluators = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedEvaluatorsTable.$el);
          self.$refs.assignedEvaluatorsTable.searchx = "";
        };

        self.$ajaxGet(self, "EvaluatorModule/ListModuleAssignedEvaluators?showInactive=" + val + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      assignEvaluator(userId) {
        var self = this;
        self.showLoadingOnElement("evaluatorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Evaluator Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.evaluatorsTable.$el);
          self.getAllEvaluators(self.moduleData.id);
          self.getAssignedEvaluators(self.showInactiveEvaluators);
        };
        self.$ajaxGet(self, "EvaluatorModule/AssignToModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      unassignEvaluator(userId) {
        var self = this;
        self.showLoadingOnElement("assignedEvaluatorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Evaluator Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.assignedEvaluatorsTable.$el);
          self.getAllEvaluators(self.moduleData.id);
          self.getAssignedEvaluators(self.showInactiveEvaluators);
        };
        self.$ajaxGet(self, "EvaluatorModule/DeactivateFromModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      getUnassignedMentors(moduleId) {
        const self = this;
        self.showLoadingOnElement("mentorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.unassignedMentors = response.data.map((item) => {return {label: item.text, value: item.value} });;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.mentorsTable.$el);
        };

        self.$ajaxGet(self, "MentorModule/getUnassignedMentors?moduleId=" + moduleId, onSuccess, onFinally);
      },
      getAssignedMentors() {
        const self = this;
        self.showLoadingOnElement("mentorsTable", 1, "corners");

        var onSuccess = function (response) {
          self.assignedMentors = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.mentorsTable.$el);
        };

        self.$ajaxGet(self, "MentorModule/getAssignedMentors?moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      assignMentor() {
        var self = this;
        if (self.mentorsDropdown) {
          self.showLoadingOnElement("mentorsTable", 1, "corners");

          var onSuccess = response => {
            self.mentorsDropdown = 0;
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: `Mentor Assigned to ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-user-check'
            });
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.mentorsTable.$el);
            self.getUnassignedMentors(self.moduleData.id);
            self.getAssignedMentors();
          };
          self.$ajaxGet(self, "MentorModule/AssignToModule?userId=" + self.mentorsDropdown.value + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
        }
      },
      unassignMentor(userId) {
        var self = this;
        self.showLoadingOnElement("mentorsTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Mentor Unassigned from ${self.$siteTypeId() == 1 ? 'Topic' : 'Module'}`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-user-minus'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.mentorsTable.$el);
          self.getUnassignedMentors(self.moduleData.id);
          self.getAssignedMentors();
        };
        self.$ajaxGet(self, "MentorModule/UnassignFromModule?userId=" + userId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      getAllSites() {
        const self = this;
        self.showLoadingOnElement("sitesTable", 1, "corners");

        var onSuccess = function (response) {
          self.sites = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.sitesTable.$el);
        };

        self.$ajaxGet(self, "SiteModule/GetAllSites?moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      getSharedSites() {
        const self = this;
        self.showLoadingOnElement("sharedSitesTable", 1, "corners");

        var onSuccess = function (response) {
          self.sitesSharedWith = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.sharedSitesTable.$el);
        };

        self.$ajaxGet(self, "SiteModule/ListModuleSharedSites?moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      shareWithSite(siteId) {
        var self = this;
        self.showLoadingOnElement("sitesTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Module shared with site",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-share-2'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.sitesTable.$el);
          self.getAllSites()
          self.getSharedSites();
        };

        self.$ajaxGet(self, "SiteModule/ShareModuleWithSite?siteId=" + siteId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      showSelectCoursePopup(siteId) {
        this.getCoursesForSite();
        this.siteToShare = siteId;
        this.coursePopupActive = true;
      },
      getCoursesForSite() {
        var self = this;
        self.showLoadingOnElement("sitesTable", 1, "corners");

        var onSuccess = response => {
          self.siteCourses = response.data.map((item) => {return {label: item.text, value: item.value} });
        };

        self.$ajaxGet(self, `Course/GetCoursesForSite/${self.siteToShare}`, onSuccess);
      },
      cloneToSite(siteId) {
        var self = this;
        if (self.siteCourseDropdown) {
          self.showLoadingOnElement("sitesTable", 1, "corners");

          var onSuccess = response => {
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Module shared with site",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-share-2'
            });
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.sitesTable.$el);
            self.getAllSites()
            self.getSharedSites();
          };

          self.$ajaxGet(self, "SiteModule/ShareModuleWithSite?siteId=" + self.siteToShare + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
        }
      },
      removeShare(siteId) {
        var self = this;
        self.showLoadingOnElement("sharedSitesTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Module sharing removed from site",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-x'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.sharedSitesTable.$el);
          self.getAllSites()
          self.getSharedSites();
        };

        self.$ajaxGet(self, "SiteModule/UnshareModule?siteId=" + siteId + "&moduleId=" + self.moduleData.id, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
      removeDoc(id) {
        var self = this;
        self.showLoadingOnElement("uploadsTable", 1, "corners");

        var onSuccess = function (response) {
          self.listDocuments();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Document Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.uploadsTable.$el);
        };

        self.$ajaxGet(self, "Module/RemoveDoc/" + id, onSuccess, onFinally);
      },
      setDefaultHoursValue(){
        var self = this;

        if(!self.moduleData.formativeHoursRequired){
          self.moduleData.formativeHoursRequired = 1;
        }

        if(!self.moduleData.summativeHoursRequired){
          self.moduleData.summativeHoursRequired = 1;
        }
      },
    }
  }

</script>

<style lang="scss">

.modulespinbuttonwidth{
  width: 80%;
}

#vsswitch{
  width: 110px !important;
}

#top-right-close {
  right: 0;
  position: absolute;
  top: 0;
  margin-right: 3px;
  margin-top: 3px;
}

#milestones-row{
  align-items: flex-end;
}

#delete-column {
  text-align: -webkit-center;
  text-align: -moz-center;
}

.numberinput{
  background: #ffffff;
  float: left;
}

#optionText_TextArea {
  width: 50%;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

#TasksTable{
  height: fit-content;
}

#studentList{
  height:fit-content;
  .vs-collapse-item--content{
    max-height: fit-content !important;
  }
}

#moduleInfoCard{
  .vs-collapse-item.open-item{
    .vs-collapse-item--content{
      max-height: fit-content !important;
    }
  }
}

#AssignTable{
  height: fit-content;
}

.info-icon-on-module{
  width: 30px;
  z-index: 5;
  text-align: justify;
  text-justify: inter-word
}

.info-next-to-checkcss{
  display: flex;

  .con-vs-checkbox{
    width: fit-content;
  }
}

</style>
